import { render, staticRenderFns } from "./CancelBatchModal.vue?vue&type=template&id=120ffe4f&"
import script from "./CancelBatchModal.vue?vue&type=script&lang=js&"
export * from "./CancelBatchModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('120ffe4f')) {
      api.createRecord('120ffe4f', component.options)
    } else {
      api.reload('120ffe4f', component.options)
    }
    module.hot.accept("./CancelBatchModal.vue?vue&type=template&id=120ffe4f&", function () {
      api.rerender('120ffe4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/submissions/CancelBatchModal.vue"
export default component.exports